import React, { useEffect, useState }  from 'react';
import Icon from '../../../components/AppIcon';
import httpHelper, { Method_TYPE } from 'utils/http-helper';
import URL_CONSTANTS  from 'constants/url-constants';
import { get } from 'react-hook-form';
const SystemStats = () => {
  const [systemStats,setSystemStats] = useState( [
    {
      label: 'Total Districts',
      key: 'totalDistricts',
      value: '0',
      icon: 'MapPin',
      color: 'primary',
      trend: null
    },
    {
      label: 'Active Samithis',
      key: 'totalSamithis',
      value: '0',
      icon: 'Building2',
      color: 'success',
      // trend: '+3 this month'
    },
    {
      label: 'Service Points',
      key: 'totalServicePoints',
      value: '0',
      icon: 'Target',
      color: 'warning',
      // trend: '+7 this week'
    },
    {
      label: 'Total Members',
      key: 'totalMembers',
      value: '0',
      icon: 'Users',
      color: 'primary',
      // trend: '+45 this month'
    }
  ]) 

  const getStatStyles = (color) => {
    const styles = {
      primary: {
        icon: 'text-primary',
        bg: 'bg-primary/10'
      },
      success: {
        icon: 'text-success',
        bg: 'bg-success/10'
      },
      warning: {
        icon: 'text-warning',
        bg: 'bg-warning/10'
      }
    };
    return styles[color] || styles.primary;
  };

  useEffect(() => {
    
    const fetchData = async () => {

      try {

        const districtCount = await getTotalDistrictCount();
        const samithiCount = await getTotalSamithiCount();
        const memberCount = await getTotalMemberCount();
        const deploymentPointCount = await getDeploymentPointCount();

        const updatedStats = [...systemStats]; // Create a copy of statusCards

        for(let iter = 0;iter < updatedStats.length;iter++){

          if(updatedStats[iter].key === 'totalDistricts'){
            updatedStats[iter].value = districtCount;
          } else if(updatedStats[iter].key === 'totalSamithis'){
            updatedStats[iter].value = samithiCount;
          } else if(updatedStats[iter].key === 'totalMembers'){
            updatedStats[iter].value = memberCount;
          } else if(updatedStats[iter].key === 'totalServicePoints'){
            updatedStats[iter].value = deploymentPointCount;
          }

        }
        setSystemStats(updatedStats); // Update the state with the new counts

      } catch (error) {

        console.error('Error fetching data:', error);

      }
    };

    fetchData(); // Initial fetch
  }, []);

  const getTotalDistrictCount = async () => {
    try {
      const result = await httpHelper(URL_CONSTANTS.DISTRICT_COUNT, Method_TYPE.GET);
      return result?.data || 0;
     
    } catch (err) {
      console.log("Fetch DISTRICT_COUNT api err", err);
      return 0;
    }
  };

  const getTotalSamithiCount = async () => {
    try {
      const result = await httpHelper(URL_CONSTANTS.SAMITHI_COUNT, Method_TYPE.GET);
      return result?.data || 0;
     
    } catch (err) {
      console.log("Fetch SAMITHI_COUNT api err", err);
      return 0;
    }
  };

  const getTotalMemberCount = async () => {
    try {
      const result = await httpHelper(URL_CONSTANTS.MEMBER_COUNT, Method_TYPE.GET);
      return result?.data || 0;
     
    } catch (err) {
      console.log("Fetch MEMBER_COUNT api err", err);
      return 0;
    }
  };

  const getDeploymentPointCount = async () => {
    try {
      const result = await httpHelper(URL_CONSTANTS.DEPLOYMENT_COUNT, Method_TYPE.GET);
      return result?.data || 0;
     
    } catch (err) {
      console.log("Fetch DEPLOYMENT_COUNT api err", err);
      return 0;
    }
  };


  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-spiritual-sm">
      <div className="mb-4">
        <h2 className="font-heading font-semibold text-lg text-foreground mb-2">
          System Overview
        </h2>
        <p className="text-sm text-muted-foreground">
          Current system statistics and metrics
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {systemStats.map((stat, index) => {
          const statStyles = getStatStyles(stat.color);
          
          return (
            <div
              key={index}
              className="text-center pt-3 pb-2 rounded-lg border border-border/50 hover:border-border transition-colors"
            >
              <div className={`
                w-12 rounded-full flex items-center justify-center mx-auto mb-2
                ${statStyles.bg}
              `}>
                <Icon 
                  name={stat.icon} 
                  size={20} 
                  className={statStyles.icon}
                />
              </div>
              
              <div className="space-y-1">
                <h3 className="text-2xl font-heading font-semibold text-foreground">
                  {stat.value}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {stat.label}
                </p>
                {stat.trend && (
                  <p className="text-xs text-success font-caption">
                    {stat.trend}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            Last updated: {new Date().toLocaleString('en-IN', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </span>
          <div className="flex items-center space-x-1 text-success">
            <div className="w-2 h-2 bg-success rounded-full animate-spiritual-pulse"></div>
            <span className="font-caption">Live</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SystemStats;